import React from "react";
import GeneralTextField, {
  IGeneralTextField,
} from "../../FormComponents/GeneralTextField";

export const GeneralTextFieldWithAutoCompleteOn = (
  props: IGeneralTextField
) => {
  return (
    <GeneralTextField
      {...props}
      domProps={
        {
          autoComplete: "on",
        } as React.HTMLAttributes<HTMLInputElement>
      }
    />
  );
};
